export default __webpack_public_path__ + "static/Entenda0103-6b70b568b58dcb6ae153890c18b75b89.jpg";